/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts'

import type { AMM } from '../AMM'

export class AMM__factory extends ContractFactory {
  constructor(linkLibraryAddresses: AMMLibraryAddresses, signer?: Signer) {
    super(_abi, AMM__factory.linkBytecode(linkLibraryAddresses), signer)
  }

  static linkBytecode(linkLibraryAddresses: AMMLibraryAddresses): string {
    let linkedBytecode = _bytecode

    linkedBytecode = linkedBytecode.replace(
      new RegExp('__\\$94a4c7b9bd68bc1262fd256c9f16212cff\\$__', 'g'),
      linkLibraryAddresses['__$94a4c7b9bd68bc1262fd256c9f16212cff$__']
        .replace(/^0x/, '')
        .toLowerCase()
    )

    return linkedBytecode
  }

  deploy(
    _uri: string,
    _aggregator: string,
    _collateral: string,
    _priceOracle: string,
    _feeRecepient: string,
    _operator: string,
    _optionContract: string,
    overrides?: Overrides
  ): Promise<AMM> {
    return super.deploy(
      _uri,
      _aggregator,
      _collateral,
      _priceOracle,
      _feeRecepient,
      _operator,
      _optionContract,
      overrides || {}
    ) as Promise<AMM>
  }
  getDeployTransaction(
    _uri: string,
    _aggregator: string,
    _collateral: string,
    _priceOracle: string,
    _feeRecepient: string,
    _operator: string,
    _optionContract: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(
      _uri,
      _aggregator,
      _collateral,
      _priceOracle,
      _feeRecepient,
      _operator,
      _optionContract,
      overrides || {}
    )
  }
  attach(address: string): AMM {
    return super.attach(address) as AMM
  }
  connect(signer: Signer): AMM__factory {
    return super.connect(signer) as AMM__factory
  }
  static connect(address: string, signerOrProvider: Signer | Provider): AMM {
    return new Contract(address, _abi, signerOrProvider) as AMM
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: 'string',
        name: '_uri',
        type: 'string'
      },
      {
        internalType: 'address',
        name: '_aggregator',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_collateral',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_priceOracle',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_feeRecepient',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_operator',
        type: 'address'
      },
      {
        internalType: 'address',
        name: '_optionContract',
        type: 'address'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
      }
    ],
    name: 'ApprovalForAll',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'asset',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'rangeId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'amount',
        type: 'uint128'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'mint',
        type: 'uint128'
      }
    ],
    name: 'Deposited',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'bool',
        name: 'isEmergencyMode',
        type: 'bool'
      }
    ],
    name: 'EmergencyStateChanged',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'seriesId',
        type: 'uint256'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'buyer',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'amount',
        type: 'uint128'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'premium',
        type: 'uint128'
      }
    ],
    name: 'OptionBought',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'uint256',
        name: 'seriesId',
        type: 'uint256'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'seller',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'amount',
        type: 'uint128'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'premium',
        type: 'uint128'
      }
    ],
    name: 'OptionSold',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'previousOwner',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'OwnershipTransferred',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'protocolFee',
        type: 'uint128'
      }
    ],
    name: 'Settled',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'values',
        type: 'uint256[]'
      }
    ],
    name: 'TransferBatch',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'TransferSingle',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'string',
        name: 'value',
        type: 'string'
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      }
    ],
    name: 'URI',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'address',
        name: 'asset',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'rangeId',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'amount',
        type: 'uint128'
      },
      {
        indexed: false,
        internalType: 'uint128',
        name: 'burn',
        type: 'uint128'
      }
    ],
    name: 'Withdrawn',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'accounts',
        type: 'address[]'
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      }
    ],
    name: 'balanceOfBatch',
    outputs: [
      {
        internalType: 'uint256[]',
        name: '',
        type: 'uint256[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_amount',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: '_maxFee',
        type: 'uint128'
      }
    ],
    name: 'buy',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_size',
        type: 'uint128'
      },
      {
        internalType: 'bool',
        name: '_isSelling',
        type: 'bool'
      }
    ],
    name: 'calculatePremium',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bool',
        name: '_isEmergencyMode',
        type: 'bool'
      }
    ],
    name: 'changeState',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_mintAmount',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: '_maxDeposit',
        type: 'uint128'
      },
      {
        internalType: 'uint32',
        name: '_tickStart',
        type: 'uint32'
      },
      {
        internalType: 'uint32',
        name: '_tickEnd',
        type: 'uint32'
      }
    ],
    name: 'deposit',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'feePool',
    outputs: [
      {
        internalType: 'contract IFeePool',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_tickStart',
        type: 'uint32'
      },
      {
        internalType: 'uint32',
        name: '_tickEnd',
        type: 'uint32'
      }
    ],
    name: 'genRangeId',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint8',
        name: '_key',
        type: 'uint8'
      }
    ],
    name: 'getConfig',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [],
    name: 'getLockupPeriod',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_depositAmount',
        type: 'uint128'
      },
      {
        internalType: 'uint32',
        name: '_tickStart',
        type: 'uint32'
      },
      {
        internalType: 'uint32',
        name: '_tickEnd',
        type: 'uint32'
      }
    ],
    name: 'getMintAmount',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_tickId',
        type: 'uint32'
      },
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      }
    ],
    name: 'getProfitState',
    outputs: [
      {
        components: [
          {
            internalType: 'int128',
            name: 'unrealizedPnL',
            type: 'int128'
          },
          {
            internalType: 'uint128',
            name: 'cumulativeFee',
            type: 'uint128'
          }
        ],
        internalType: 'struct AMMLib.Profit',
        name: '',
        type: 'tuple'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_rangeId',
        type: 'uint128'
      }
    ],
    name: 'getRange',
    outputs: [
      {
        internalType: 'uint32',
        name: '_start',
        type: 'uint32'
      },
      {
        internalType: 'uint32',
        name: '_end',
        type: 'uint32'
      }
    ],
    stateMutability: 'pure',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_tickLower',
        type: 'uint32'
      },
      {
        internalType: 'uint32',
        name: '_tickUpper',
        type: 'uint32'
      }
    ],
    name: 'getSecondsPerLiquidity',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_tickId',
        type: 'uint32'
      },
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      }
    ],
    name: 'getSeriesState',
    outputs: [
      {
        components: [
          {
            internalType: 'uint32',
            name: 'tickId',
            type: 'uint32'
          },
          {
            internalType: 'bool',
            name: 'isLong',
            type: 'bool'
          },
          {
            internalType: 'uint128',
            name: 'ivMove',
            type: 'uint128'
          },
          {
            internalType: 'uint128',
            name: 'tradeTime',
            type: 'uint128'
          }
        ],
        internalType: 'struct AMMLib.LockedOptionStatePerTick',
        name: '',
        type: 'tuple'
      },
      {
        internalType: 'bool',
        name: 'exists',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_tickStart',
        type: 'uint32'
      },
      {
        internalType: 'uint32',
        name: '_tickEnd',
        type: 'uint32'
      }
    ],
    name: 'getTicks',
    outputs: [
      {
        components: [
          {
            internalType: 'uint128',
            name: 'supply',
            type: 'uint128'
          },
          {
            internalType: 'uint128',
            name: 'balance',
            type: 'uint128'
          },
          {
            internalType: 'int128',
            name: 'unrealizedPnL',
            type: 'int128'
          },
          {
            internalType: 'uint128',
            name: 'lastSupply',
            type: 'uint128'
          },
          {
            internalType: 'uint128',
            name: 'lastBalance',
            type: 'uint128'
          },
          {
            internalType: 'uint128',
            name: 'secondsPerLiquidity',
            type: 'uint128'
          },
          {
            internalType: 'uint128',
            name: 'burnReserved',
            type: 'uint128'
          },
          {
            internalType: 'uint128',
            name: 'reservationForWithdrawal',
            type: 'uint128'
          }
        ],
        internalType: 'struct AMMLib.Tick[]',
        name: '',
        type: 'tuple[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_burnAmount',
        type: 'uint128'
      },
      {
        internalType: 'uint32',
        name: '_tickStart',
        type: 'uint32'
      },
      {
        internalType: 'uint32',
        name: '_tickEnd',
        type: 'uint32'
      }
    ],
    name: 'getWithdrawableAmount',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'operator',
        type: 'address'
      }
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    name: 'lastProvidedAt',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      },
      {
        internalType: 'uint256[]',
        name: 'values',
        type: 'uint256[]'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'onERC1155BatchReceived',
    outputs: [
      {
        internalType: 'bytes4',
        name: '',
        type: 'bytes4'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'onERC1155Received',
    outputs: [
      {
        internalType: 'bytes4',
        name: '',
        type: 'bytes4'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'owner',
    outputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint32',
        name: '_tickId',
        type: 'uint32'
      },
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      }
    ],
    name: 'rebalanceCollateral',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [],
    name: 'renounceOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    name: 'reservations',
    outputs: [
      {
        internalType: 'uint128',
        name: 'burn',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: 'withdrawableTimestamp',
        type: 'uint128'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_reserveAmount',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: '_rangeId',
        type: 'uint128'
      }
    ],
    name: 'reserveWithdrawal',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      },
      {
        internalType: 'uint256[]',
        name: 'amounts',
        type: 'uint256[]'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'safeBatchTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_seriesId',
        type: 'uint256'
      },
      {
        internalType: 'uint128',
        name: '_amount',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: '_minFee',
        type: 'uint128'
      }
    ],
    name: 'sell',
    outputs: [
      {
        internalType: 'uint128',
        name: '',
        type: 'uint128'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_address',
        type: 'address'
      },
      {
        internalType: 'bool',
        name: '_isAllowed',
        type: 'bool'
      }
    ],
    name: 'setAddressAllowedSkippingLockup',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
      }
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_bot',
        type: 'address'
      }
    ],
    name: 'setBot',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint8',
        name: '_key',
        type: 'uint8'
      },
      {
        internalType: 'uint128',
        name: '_value',
        type: 'uint128'
      }
    ],
    name: 'setConfig',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_feeRecipient',
        type: 'address'
      }
    ],
    name: 'setFeeRecipient',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_lockupPeriod',
        type: 'uint256'
      }
    ],
    name: 'setLockupPeriod',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: '_operator',
        type: 'address'
      }
    ],
    name: 'setNewOperator',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '_expiryId',
        type: 'uint256'
      }
    ],
    name: 'settle',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4'
      }
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'newOwner',
        type: 'address'
      }
    ],
    name: 'transferOwnership',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    name: 'uri',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint128',
        name: '_burnAmount',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: '_minWithdrawal',
        type: 'uint128'
      },
      {
        internalType: 'uint128',
        name: '_rangeId',
        type: 'uint128'
      },
      {
        internalType: 'bool',
        name: '_useReservation',
        type: 'bool'
      }
    ],
    name: 'withdraw',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  }
]

const _bytecode =
  '0x6080604052621275006012553480156200001857600080fd5b506040516200485e3803806200485e8339810160408190526200003b9162000235565b86620000478162000159565b50600380546001600160a01b0319163390811790915560405181906000907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908290a350600e80546001600160a01b03199081166001600160a01b03858116918217909355600f805483169091179055600c80548216878416179055600d8054909116858316179055604051638ade331b60e01b815260048082015287821660248201528682166044820152908216606482015273__$94a4c7b9bd68bc1262fd256c9f16212cff$__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__$94a4c7b9bd68bc1262fd256c9f16212cff$__90636a39c38c906108d790600490879087908a90840161411e565b60206040518083038186803b1580156108ef57600080fd5b505af4158015610903573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109279190613a45565b949350505050565b60408051608081018252600080825260208201819052918101829052606081018290529061095f60048486612e70565b915091509250929050565b6060600280546109799061427d565b80601f01602080910402602001604051908101604052809291908181526020018280546109a59061427d565b80156109f25780601f106109c7576101008083540402835291602001916109f2565b820191906000526020600020905b8154815290600101906020018083116109d557829003601f168201915b50505050509050919050565b600080836001600160801b031611610a585760405162461bcd60e51b815260206004820152601760248201527f414d4d3a2073697a65206d757374206e6f7420626520300000000000000000006044820152606401610814565b6000610a62612fe6565b604051632087d9d360e21b8152600480820152602481018790526001600160801b03808716604483015282166064820152841515608482015290915073__$94a4c7b9bd68bc1262fd256c9f16212cff$__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__$94a4c7b9bd68bc1262fd256c9f16212cff$__9063d1c65e62906108d790600490879087908a90840161411e565b60608151835114610f365760405162461bcd60e51b815260206004820152602960248201527f455243313135353a206163636f756e747320616e6420696473206c656e677468604482015268040dad2e6dac2e8c6d60bb1b6064820152608401610814565b6000835167ffffffffffffffff811115610f6057634e487b7160e01b600052604160045260246000fd5b604051908082528060200260200182016040528015610f89578160200160208202803683370190505b50905060005b845181101561102b57610ff0858281518110610fbb57634e487b7160e01b600052603260045260246000fd5b6020026020010151858381518110610fe357634e487b7160e01b600052603260045260246000fd5b60200260200101516107ac565b82828151811061101057634e487b7160e01b600052603260045260246000fd5b6020908102919091010152611024816142e5565b9050610f8f565b509392505050565b6000826001600160801b03161161105c5760405162461bcd60e51b815260040161081490613fec565b60008061106883612e02565b60405163145453b560e01b815263ffffffff808416600483015282166024820152919350915073__$94a4c7b9bd68bc1262fd256c9f16212cff$__9063145453b59060440160006040518083038186803b1580156110c557600080fd5b505af41580156110d9573d6000803e3d6000fd5b50503360009081526010602090815260408083206001600160801b03808a168552925290912080549093506111109250168661416d565b6001600160801b031661112c33866001600160801b03166107ac565b101561117a5760405162461bcd60e51b815260206004820152601860248201527f414d4d3a20616d6f756e7420697320746f6f206c6172676500000000000000006044820152606401610814565b6005546040805163771e567360e01b815290516000926001600160a01b03169163771e5673916004828101926020929190829003018186803b1580156111bf57600080fd5b505afa1580156111d3573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906111f79190613c92565b60405163a616903360e01b815267ffffffffffffffff91909116915073__$94a4c7b9bd68bc1262fd256c9f16212cff$__9063a61690339061124390600490889088908c90840161411e565b60006040518083038186803b15801561125b57600080fd5b505af415801561126f573d6000803e3d6000fd5b505083546001600160801b03161591506112db9050578154869083906000906112a29084906001600160801b031661416d565b82546001600160801b039182166101009390930a9283029282021916919091179091558354838216600160801b02911617835550610e89565b6040805180820182526001600160801b039788168152918716602080840191825233600090815260108252838120988a16815297905295209051815495518716600160801b029087166001600160801b03199096169590951790951693909317909355505050565b600e546001600160a01b0316331461136d5760405162461bcd60e51b8152600401610814906140b2565b600f80546001600160a01b0319166001600160a01b0392909216919091179055565b33611398611549565b6001600160a01b0316146113ee5760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e65726044820152606401610814565b6003546040516000916001600160a01b0316907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908390a3600380546001600160a01b0319169055565b60405163145453b560e01b815263ffffffff80841660048301528216602482015260009073__$94a4c7b9bd68bc1262fd256c9f16212cff$__9063145453b59060440160006040518083038186803b15801561149357600080fd5b505af41580156114a7573d6000803e3d6000fd5b5050604051630e64fdcf60e41b81526007600482015263ffffffff80871660248301528516604482015273__$94a4c7b9bd68bc1262fd256c9f16212cff$__925063e64fdcf0915060640160206040518083038186803b15801561150a57600080fd5b505af415801561151e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906115429190613a45565b9392505050565b6003546001600160a01b03165b90565b600f546001600160a01b031633146115b35760405162461bcd60e51b815260206004820152601760248201527f414d4d3a2063616c6c6572206d75737420626520626f740000000000000000006044820152606401610814565b604051631ef7d0df60e31b81526004808201526024810182905260009073__$94a4c7b9bd68bc1262fd256c9f16212cff$__9063f7be86f89060440160206040518083038186803b15801561160757600080fd5b505af415801561161b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061163f9190613a45565b90506001600160801b0381161561173e57600654600d5460405163095ea7b360e01b81526001600160a01b039283169263095ea7b392611686929116908590600401613e17565b602060405180830381600087803b1580156116a057600080fd5b505af11580156116b4573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906116d891906139d5565b50600d546040516301acfa2360e51b81526001600160a01b039091169063359f44609061170b9030908590600401613e17565b600060405180830381600087803b15801561172557600080fd5b505af1158015611739573d6000803e3d6000fd5b505050505b6040516001600160801b038216815282907f7803d245549ac5af333ca21d9878b6778a0058d1a3bcf687daec0050181e0a619060200160405180910390a25050565b600f54600160a01b900460ff16156117aa5760405162461bcd60e51b815260040161081490613fbf565b60405163145453b560e01b815263ffffffff80841660048301528216602482015273__$94a4c7b9bd68bc1262fd256c9f16212cff$__9063145453b59060440160006040518083038186803b15801561180257600080fd5b505af4158015611816573d6000803e3d6000fd5b5050604051639667903d60e01b81526000925073__$94a4c7b9bd68bc1262fd256c9f16212cff$__9150639667903d9061185a90600490879087908b90840161411e565b60206040518083038186803b15801561187257600080fd5b505af4158015611886573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906118aa9190613a45565b90506000816001600160801b0316116118d55760405162461bcd60e51b815260040161081490613fec565b836001600160801b0316816001600160801b031611156119495760405162461bcd60e51b815260206004820152602960248201527f414d4d3a20616d6f756e74206465706f73697465642069732067726561746572604482015268040e8d0c2dc40dac2f60bb1b6064820152608401610814565b60006119558484610b98565b905061198433826001600160801b0316886001600160801b031660405180602001604052806000815250613273565b6006546040516323b872dd60e01b81523360048201523060248201526001600160801b03841660448201526001600160a01b03909116906323b872dd90606401602060405180830381600087803b1580156119de57600080fd5b505af11580156119f2573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611a1691906139d5565b50336000818152601160205260409081902042905560065490517f40c122d538239535f585c7c7e9f88c3695a33dd06199d73310cd7a449ea9a9e991611a6d916001600160a01b0390911690859087908c90613e39565b60405180910390a2505050505050565b600f54600160a01b900460ff1615611aa75760405162461bcd60e51b815260040161081490613fbf565b6000826001600160801b031611611afc5760405162461bcd60e51b81526020600482015260196024820152780414d4d3a20616d6f756e74206d757374206e6f74206265203603c1b6044820152606401610814565b6000611b06612fe6565b604051631af7660d60e31b815290915060009073__$94a4c7b9bd68bc1262fd256c9f16212cff$__9063d7bb306890611b4b90600490899089908890339085016140e9565b60206040518083038186803b158015611b6357600080fd5b505af4158015611b77573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611b9b9190613a45565b9050826001600160801b0316816001600160801b03161115611c0b5760405162461bcd60e51b815260206004820152602360248201527f414d4d3a20746f74616c206665652065786365656473206d6178466565416d6f6044820152621d5b9d60ea1b6064820152608401610814565b6006546040516323b872dd60e01b81523360048201523060248201526001600160801b03831660448201526001600160a01b03909116906323b872dd90606401602060405180830381600087803b158015611c6557600080fd5b505af1158015611c79573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611c9d91906139d5565b50604080518681526001600160801b038681166020830152831681830152905133917fc3d8029799b214ab0f4f8592586094fdc7a501bcf8e97e7f4a3fa57bca5d0565919081900360600190a25050505050565b600e546001600160a01b03163314611d1b5760405162461bcd60e51b8152600401610814906140b2565b6040516322dc9c5560e11b815260048082015263ffffffff831660248201526044810182905273__$94a4c7b9bd68bc1262fd256c9f16212cff$__906345b938aa9060640160006040518083038186803b158015611d7857600080fd5b505af4158015610e89573d6000803e3d6000fd5b336001600160a01b0383161415611df75760405162461bcd60e51b815260206004820152602960248201527f455243313135353a2073657474696e6720617070726f76616c20737461747573604482015268103337b91039b2b63360b91b6064820152608401610814565b3360008181526001602090815260408083206001600160a01b0387168085529252909120805460ff1916841515179055906001600160a01b03167f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c3183604051611e64911515815260200190565b60405180910390a35050565b600e546001600160a01b03163314611e9a5760405162461bcd60e51b8152600401610814906140b2565b6001600160a01b03919091166000908152601360205260409020805460ff1916911515919091179055565b600f54600160a01b900460ff1615611eef5760405162461bcd60e51b815260040161081490613fbf565b600080611efb84612e02565b3360009081526010602090815260408083206001600160801b038a81168552908352928190208151808301835290548085168252600160801b9004909316918301919091525163145453b560e01b815263ffffffff8085166004830152831660248201529294509092509073__$94a4c7b9bd68bc1262fd256c9f16212cff$__9063145453b59060440160006040518083038186803b158015611f9d57600080fd5b505af4158015611fb1573d6000803e3d6000fd5b50505050866001600160801b0316611fd233876001600160801b03166107ac565b10156120365760405162461bcd60e51b815260206004820152602d60248201527f414d4d3a206d73672e73656e64657220646f65736e2774206861766520656e6f60448201526c756768204c5020746f6b656e7360981b6064820152608401610814565b600084156122015781600001516001600160801b0316886001600160801b031611156120a45760405162461bcd60e51b815260206004820181905260248201527f414d4d3a206275726e416d6f756e74206d7573742062652072657365727665646044820152606401610814565b81602001516001600160801b031642116121125760405162461bcd60e51b815260206004820152602960248201527f414d4d3a20776974686472617761626c6520706572696f64206d7573742068616044820152681d99481c185cdcd95960ba1b6064820152608401610814565b604051635994b37360e01b815273__$94a4c7b9bd68bc1262fd256c9f16212cff$__90635994b3739061214f90600490889088908e90840161411e565b60206040518083038186803b15801561216757600080fd5b505af415801561217b573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061219f9190613a45565b3360009081526010602090815260408083206001600160801b03808c1685529252822080549394508b939092916121d891859116614221565b92506101000a8154816001600160801b0302191690836001600160801b031602179055506122f5565b81516001600160801b0316156122655760405162461bcd60e51b815260206004820152602360248201527f414d4d3a207265736572766174696f6e206d757374206e6f742062652065786960448201526273747360e81b6064820152608401610814565b60405163377e576160e01b815273__$94a4c7b9bd68bc1262fd256c9f16212cff$__9063377e5761906122a290600490889088908e90840161411e565b60206040518083038186803b1580156122ba57600080fd5b505af41580156122ce573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906122f29190613a45565b90505b6000816001600160801b03161161231e5760405162461bcd60e51b815260040161081490613fec565b61233b33876001600160801b03168a6001600160801b031661337b565b866001600160801b0316816001600160801b0316101561239d5760405162461bcd60e51b815260206004820152601d60248201527f414d4d3a205f6275726e416d6f756e7420697320746f6f20736d616c6c0000006044820152606401610814565b60065460405163a9059cbb60e01b81526001600160a01b039091169063a9059cbb906123cf9033908590600401613e17565b602060405180830381600087803b1580156123e957600080fd5b505af11580156123fd573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061242191906139d5565b5060065460405133917fad889894fe8f1e80feb449ec9f63d45b30953f853f2fa1a080be3c9b5a20718691612465916001600160a01b0316908a9086908e90613e39565b60405180910390a25050505050505050565b600e546001600160a01b031633146124a15760405162461bcd60e51b8152600401610814906140b2565b601255565b60405163145453b560e01b815263ffffffff80841660048301528216602482015260609073__$94a4c7b9bd68bc1262fd256c9f16212cff$__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__$94a4c7b9bd68bc1262fd256c9f16212cff$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'

export interface AMMLibraryAddresses {
  ['__$94a4c7b9bd68bc1262fd256c9f16212cff$__']: string
}
